import JoditEditor from "jodit-react";
import React, { useMemo, useRef, useState } from "react";
import { htmlToJsx } from "html-to-jsx-transform";
import { v4 as uuidv4 } from "uuid";
const uuid = uuidv4();
const TextGenerator = ({ openModal }) => {
  const editor = useRef(null);
  const [content, setContent] = useState("");

  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      //  placeholder: placeholder || "Start typings...",
    })
    //  [placeholder]
  );
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = `<div id="${uuid}" />` + htmlToJsx(content);
    /*const result =
      "<div " +
      "dangerouslySetInnerHTML={{__html:" +
      JSON.stringify(content) +
      "}}/>";*/

    openModal(result);
  };
  return (
    <div className="grid  m-auto p-2 ">
      <div className="max-w-full overflow-x-auto text-justify">
        <JoditEditor
          ref={editor}
          value={content}
          config={config}
          tabIndex={1} // tabIndex of textarea
          onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
          onChange={(newContent) => {}}
        />
      </div>
      <div className="p-4 m-auto">
        <button
          className=" btn btn-square min-w-40  m-auto "
          onClick={handleSubmit}
          type="reset"
        >
          Create
        </button>
      </div>
    </div>
  );
};

export default TextGenerator;
